//////////////////////////////////////////////////////////////////////
//
//  10/12/18
//  src/containers/RestData.js
//
//  This file will contain all the 'canned' Restaurant Data.
//

//
//  This is the raw Restaurant data.
//
const RestData = [
 {
   miles : "2.1  mi.",
   name  : "Perfect Pear Bistro",
   music : false,
   food  : true,
   happy : true,
   notes : true,
   board : false,
   line1 : "",
   line2 : "",
   line3 : "",
   line4 : "",
   mpop  : "",
   fpop  : "American Comfort Food",
   hpop  : "Happy Hour Daily 3-6 PM",
   addr  : "http://www.perfectpearbistro.com/",
 },
 {
   miles : "4.4  mi.",
   name  : "The Arrogant Butcher",
   music : false,
   food  : true,
   happy : true,
   notes : true,
   board : true,
   line1 : "The Arrogant Butcher",
   line2 : "YES!  We have seafood!",
   line3 : "World Famous Turkey Pastrami",
   line4 : "Quality Food & Premium Drinks",
   mpop  : "",
   fpop  : "Special Today: Turkey Pastrami",
   hpop  : "Happy Hour M-F 3-6 PM",
   addr  : "https://www.foxrc.com/restaurants/the-arrogant-butcher",
 },
 {
   miles : "5.2  mi.",
   name  : "Little Miss BBQ",
   music : false,
   food  : true,
   happy : false,
   notes : true,
   board : false,
   line1 : "",
   line2 : "",
   line3 : "",
   line4 : "",
   mpop  : "",
   fpop  : "Central Texas style BBQ",
   hpop  : "",
   addr  : "https://www.littlemissbbq.com/",
 },
 {
   miles : "6.1  mi.",
   name  : "Angry Crab Shack",
   music : true,
   food  : true,
   happy : true,
   notes : true,
   board : true,
   line1 : "Angry Crab Shack",
   line2 : "Seafood, Cajun, Creole",
   line3 : "Best Crawfish in the Valley",
   line4 : "King Crab legs",
   mpop  : "Join us Sunday for Music: 2-5pm",
   fpop  : "Sunday Creole",
   hpop  : "Happy Hour Daily",
   addr  : "https://www.angrycrabshack.com/",
 },
 {
   miles : "6.7  mi.",
   name  : "Sushi Nakano",
   music : false,
   food  : true,
   happy : false,
   notes : false,
   board : false,
   line1 : "",
   line2 : "",
   line3 : "",
   line4 : "",
   mpop  : "",
   fpop  : "Special Today: Spicy Salmon Rolls",
   hpop  : "",
   addr  : "",
 },
 {
   miles : "7.0  mi.",
   name  : "Culinary Dropout",
   music : false,
   food  : true,
   happy : true,
   notes : true,
   board : true,
   line1 : "Drop In for Lunch",
   line2 : "Try our Pretzle Bites and Fondue",
   line3 : "Fondue?  I LOVE Fondue!",
   line4 : "Damn Good Food",
   mpop  : "",
   fpop  : "Special Today: Soft Pretzels and Provolone Fondue",
   hpop  : "Happy Hour M-F 3-6 PM",
   addr  : "https://www.culinarydropout.com/",
 },
 {
   miles : "8.9  mi.",
   name  : "Sakura Sushi",
   music : false,
   food  : true,
   happy : false,
   notes : false,
   board : true,
   line1 : "Sushi with Soup and Salad",
   line2 : "Try our Las Vegas Rolls",
   line3 : "Open at 11:00 AM for Lunch",
   line4 : "",
   mpop  : "",
   fpop  : "Dessert? How about Green Tea Ice Cream",
   hpop  : "",
   addr  : "",
 },
 {
   miles : "12.4  mi.",
   name  : "Great Wok",
   music : false,
   food  : true,
   happy : true,
   notes : false,
   board : false,
   line1 : "",
   line2 : "",
   line3 : "",
   line4 : "",
   mpop  : "",
   fpop  : "Special Today: Crab Puffs",
   hpop  : "Daily Drink Specials",
   addr  : "",
 },
 {
   miles : "15.5  mi.",
   name  : "Kai",
   music : false,
   food  : true,
   happy : true,
   notes : false,
   board : true,
   line1 : "Kai at Wild Horse Pass",
   line2 : "Happy Hour every day 3-7",
   line3 : "Discount for Poker Players",
   line4 : "",
   mpop  : "",
   fpop  : "Special Today: Chicken Soup",
   hpop  : "Happy Hour Daily 3-7 PM",
   addr  : "",
 },
 {
   miles : "16.0  mi.",
   name  : "Espos Mexican Food",
   music : false,
   food  : true,
   happy : false,
   notes : true,
   board : true,
   line1 : "Mexican Foot",
   line2 : "Taco Tuesday",
   line3 : "Red and Green Chile",
   line4 : "Childrens Menu",
   mpop  : "",
   fpop  : "Today's Special: Chicken Enchiladas",
   hpop  : "",
   addr  : "https://www.espos.co/",
 },
];

export default RestData;



// WEBPACK FOOTER //
// ./src/components/RestData.js